import { PodborkaLink } from "@project/shared-types";
import { Link } from "../../components/link/link";
import { _style } from "../../core/core";
import "./PodborkiList.css";

import { useState } from "react";
import { Button } from "../../components/button/button";

export const PodborkiList = ({ podborki }: { podborki: PodborkaLink[] }) => {
  const [visibleCount, setVisibleCount] = useState(10);

  const showMore = () => {
    setVisibleCount((prevCount) => prevCount + 10);
  };

  return (
    <div className="podborki">
      {podborki.map((x, index) => (
        <Link
          key={x.url}
          style={_style.secondary2}
          link={`/podborki/${x.url}/`}
          className={index < visibleCount ? "" : "hidde_podborka"}
        >
          {x.title}
        </Link>
      ))}
      {visibleCount < podborki.length && (
        <Button onClick={showMore} style={_style.secondary2}>
          Показать ещё
        </Button>
      )}
    </div>
  );
};
